var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.$store.getters.getUrl('cp_xian'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }